/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StationTicketsStats } from '../../models/station-tickets-stats';
import { UidsBody } from '../../models/uids-body';

export interface GetTicketsStations$Params {
      body: UidsBody
}

export function getTicketsStations(http: HttpClient, rootUrl: string, params: GetTicketsStations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StationTicketsStats>>> {
  const rb = new RequestBuilder(rootUrl, getTicketsStations.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<StationTicketsStats>>;
    })
  );
}

getTicketsStations.PATH = '/stations/tickets/stats';
